import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { CREATE_LESSON, UPDATE_LESSON } from "../../../Schema/Lesson";

const useLessonForm = ({
  mutationDelete,
  editData,
  profileHook,
  handleClose,
  resetForm,
  setRefetch,
}) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createLesson] = useMutation(CREATE_LESSON, {
    onCompleted: ({ createLesson }) => {
      setLoading(false);

      if (createLesson?.isSuccess === true) {
        setAlert(true, "success", createLesson?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createLesson?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateLesson] = useMutation(UPDATE_LESSON, {
    onCompleted: ({ updateLesson }) => {
      setLoading(false);
      if (updateLesson?.isSuccess === true) {
        setAlert(true, "success", updateLesson?.message);
        handleClose();
        resetForm();
        setRefetch();
        if (profileHook && editData?.image) {
          let splitSrc = editData?.image?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", updateLesson?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateLesson, createLesson, loading, setLoading };
};

export default useLessonForm;
